<template>
  <!-- eslint-disable vue/no-use-v-if-with-v-for -->
  <Intersect @enter="showFooter()">
    <footer class="lazy-min-height">
      <div
        v-if="isShowFooter"
        class="footer--uniform footer-review"
        :class="{ 'filter-showing': !isDesktop && $route.name == 'Search' }"
      >
        <div class="container">
          <div class="row">
            <template v-if="isDesktop && !isExpertPage">
              <div class="box-footer--product-category">
                <div v-for="(dep, keyDep) in listDepartement" :key="keyDep" class="category-menu">
                  <h4>{{ dep.name }}</h4>
                  <ul>
                    <Intersect @enter="getChildCategories">
                      <div class="lazy-pixel">
                        <li>
                          <template
                            v-for="(cat, keyCat) in listCategories(keyDep)"
                            v-if="$options.filters.slug(cat.name) != 'fragrance'"
                          >
                            <router-link
                              v-if="$options.filters.slug(cat.name) != 'others'"
                              :key="keyCat"
                              :to="`/category/${cat.my_soco_sql_id}/${$options.filters.slug(cat.name)}`"
                              >{{ cat.name }}
                              <span v-if="keyCat < listCategories(keyDep).length - 1">,&nbsp;</span>
                            </router-link>
                          </template>
                          <template v-else-if="listCategories(keyDep) && listCategories(keyDep)[0]">
                            <router-link
                              v-for="(cat, keyCat) in listCategories(keyDep)[0].sub_categories"
                              v-if="keyCat < 5"
                              :key="keyCat"
                              :to="`/category/${cat.my_soco_sql_id}/${$options.filters.slug(cat.name)}`"
                              >{{ cat.name }}
                              <span v-if="keyCat < listCategories(keyDep)[0].sub_categories.length - 1">,&nbsp;</span>
                            </router-link>
                          </template>
                        </li>
                      </div>
                    </Intersect>
                    <!-- <li>
                      <router-link :to="`/category/${dep.my_soco_sql_id}/${$options.filters.slug(dep.name)}`"
                        >See All {{ dep.name }}</router-link
                      >
                    </li> -->
                  </ul>
                </div>
              </div>
              <hr class="separator only-desktop" />
            </template>
            <div class="box-footer--content">
              <div class="footer-left">
                <div class="footer-menu">
                  <h4>Information</h4>
                  <ul class="sub-menu-information">
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/aboutus`" target="_blank" rel="noopener">Tentang Kami</a>
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/privacypolicy`" target="_blank" rel="noopener"
                        >Kebijakan Privasi</a
                      >
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/termsandconditions`" target="_blank" rel="noopener"
                        >Syarat dan Ketentuan</a
                      >
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/help`">Pusat Bantuan</a>
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/contactus`">Kontak Kami</a>
                    </li>
                  </ul>
                  <ul class="sub-menu-mobile-information">
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/aboutus`" target="_blank" rel="noopener">Tentang Kami</a>
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/privacypolicy`" target="_blank" rel="noopener"
                        >Kebijakan Privasi</a
                      >
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/termsandconditions`" target="_blank" rel="noopener"
                        >Syarat dan Ketentuan</a
                      >
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/help`">Pusat Bantuan</a>
                    </li>
                    <li>
                      <a :href="`${SOCO_WEB_URL}/page/contactus`">Kontak Kami</a>
                    </li>
                  </ul>
                </div>
                <div class="title-office">
                  <h4>Find Us On</h4>
                  <p>
                    PT Sociolla Ritel Indonesia
                    <br />
                    St. Moritz Office Tower, Unit 0501,<br />
                    Puri Indah CBD Blok U1, Jalan Puri Indah Raya,<br />
                    Desa/Kelurahan Kembangan Selatan, Kec. Kembangan,<br />
                    Kota Adm. Jakarta Barat, Provinsi DKI Jakarta, 11610
                  </p>
                  <!-- <ul class="list--socmed">
                    <li>
                      <a href="https://www.facebook.com/beautyjournalid">
                        <img src="/assets/img/icons/icon-facebook.png" height="18px" alt="icon-facebook">
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/beautyjournal">
                        <img src="/assets/img/icons/icon-instagram.png" height="18px" alt="icon-instagram">
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/beautyjournalid">
                        <img src="/assets/img/icons/icon-twitter.png" height="18px" alt="icon-twitter">
                      </a>
                    </li>
                    <li>
                      <a href="https://line.me/ti/p/%40lcu1578a">
                        <img src="/assets/img/icons/icon-line.png" height="18px" alt="icon-line">
                      </a>
                    </li>
                  </ul> -->
                </div>
              </div>
              <div class="footer-right">
                <!--  <div class="title-office">
                  <h4>NEWSLETTER SUBSCRIPTION</h4>
                  <div class="send-email">
                    <form>
                      <input type="email" name placeholder="Enter your e-mail">
                      <div class="button--uniform">
                        <input class="btn red text-uppercase" type="submit" name value="Subscribe">
                      </div>
                    </form>
                  </div>
                </div> -->
                <div class="customer-care">
                  <h4>Customer Care</h4>
                  <ul>
                    <!-- <li>
                      <a href="tel:02150806418">
                        <span>(021) 5080 6418</span>
                      </a>
                    </li> -->
                    <li>
                      <a href="mailto:cs@sociolla.com">
                        <span>cs@sociolla.com</span>
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="apps-wrapper">
                  <h4>Our Mobile App</h4>
                  <ApplicationWrapper></ApplicationWrapper>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <div class="container">
            <div class="row">
              <div class="footer-bottom--content">
                <div class="footer-list-image">
                  <a :href="$store.state.SOCO_WEB_URL" class="soco">
                    <!-- <img src="/assets/img/logo-header-soco.svg"> -->
                    <SvgImg v-if="isDesktop" id="logo-header-soco" name="logo-header-soco" width="90" height="40" />
                    <SvgImg v-else id="logo-header-soco" name="logo-header-soco" width="70" height="15" />
                  </a>
                  <a :href="$store.state.BJ_WEB_URL" class="beauty-journal">
                    <img
                      v-if="isDesktop"
                      id="bj-logo-new"
                      name="bj-logo-new"
                      src="/assets/img/sprite-icon-svg/bj-logo-new.svg"
                      width="90"
                      height="40"
                    />
                    <img
                      v-else
                      id="bj-logo-new"
                      name="bj-logo-new"
                      src="/assets/img/sprite-icon-svg/bj-logo-new.svg"
                      width="70"
                      height="15"
                    />
                  </a>
                  <a :href="$store.state.SOCIOLLA_WEB_URL" class="sociolla">
                    <!-- <img src="/assets/img/logo-lulla.svg"> -->
                    <img
                      v-if="isDesktop"
                      id="logo-header-sociolla"
                      name="logo-header-sociolla"
                      src="/assets/img/sprite-icon-svg/logo-header-sociolla.svg"
                      width="90"
                      height="50"
                    />
                    <img
                      v-else
                      id="logo-header-sociolla"
                      name="logo-header-sociolla"
                      src="/assets/img/sprite-icon-svg/logo-header-sociolla.svg"
                      width="70"
                      height="45"
                    />
                  </a>
                  <a :href="$store.state.LULLA_WEB_URL" class="lulla">
                    <img
                      v-if="isDesktop"
                      id="logo-header-lulla"
                      src="/assets/img/logo-lilla.svg"
                      width="90"
                      alt="lulla"
                    />
                    <img v-else id="logo-header-lulla" src="/assets/img/logo-lilla.svg" width="70" alt="lulla" />
                  </a>
                </div>
                <span class="right-bottom">PT. Sociolla Ritel Indonesia {{ currentYear }}, All Rights Reserved.</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showScrollTop"
          class="back_top hidden-mobile clickable"
          style="display: block"
          @scroll="handleScroll()"
          @click="scrollToTop()"
        >
          <i class="arrow_carrot-up"></i>
        </div>
      </div>
    </footer>
  </Intersect>
</template>

<script>
export default {
  name: 'my-footer',
  components: {
    ApplicationWrapper: () =>
      import(/* webpackChunkName: "footer" */ '@/components/global/footer/application-section/application-section'),
  },
  data() {
    return {
      showScrollTop: false,
      called: false,
      isShowFooter: false,
    };
  },
  computed: {
    REVIEW_WEB_URL() {
      return this.$store.state.REVIEW_WEB_URL;
    },
    BJ_WEB_URL() {
      return this.$store.state.BJ_WEB_URL;
    },
    SOCO_WEB_URL() {
      return this.$store.state.SOCO_WEB_URL;
    },
    LULLA_WEB_URL() {
      return this.$store.state.LULLA_WEB_URL;
    },
    listDepartement() {
      return this.$store.state.header.categoriesOfDepartment || [];
    },
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    currentYear() {
      return dayjs().year();
    },
    isExpertPage() {
      return ['/expert'].includes(this.$route.path);
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    handleScroll() {
      this.showScrollTop = window.scrollY > 300 ? true : false;
    },
    listCategories(key) {
      return this.listDepartement[key] ? this.listDepartement[key].children : [];
    },
    getChildCategories() {
      if (!this.called) {
        this.called = true;
        this.listDepartement
          .filter((x) => !x.children)
          .forEach((it, key) => {
            this.$store.dispatch('getChildrenOfDepartments', {
              categoryId: it._id,
              categoriesOfDepartmentKey: key,
            });
          });
      }
    },
    showFooter() {
      this.isShowFooter = true;
    },
  },
};
</script>
<style scoped>
.filter-showing {
  margin-bottom: 55px;
}
</style>
